module.exports = __webpack_public_path__ + "img/Icon_Lock_light.725dfe84.svg";